export const OneDriveText = "TgscH";
export default {OneDriveText};